import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {SessionActions} from "../../../shared/actions";
import {IUser} from "../../../shared/redux-store/session/session.types";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {UserFormComponent} from "../../../crm/components/user-form/user-form.component";
import {UserService} from "../../../crm/user/user.service";
import {MessageType} from "../../../shared/redux-store/session";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";

@Component({
  selector: 'vb-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent extends AbstractListView implements OnInit, OnChanges {

  @ViewChild('usersTable')
  usersTable: DatatableComponent;

  @ViewChild('userModal')
  userModal: GenericModalComponent;

  @Input()
  userList: IUser[];

  currentUserItem: IUser;
  currentUserControl: FormGroup = UserFormComponent.initControl(this.fb);

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder, private userService: UserService) {
    super(sessionActions, cd);
  }


  ngOnInit() {

    this.columns = [
      {prop: 'email', name: 'Benutzer', flexGrow: 2},
      {prop: 'name', name: 'Name', flexGrow: 2},
      {prop: 'pre_name', name: 'Vorname', flexGrow: 2},
      //{prop: 'administration_unit.label', name: 'Verwaltungseinheit', flexGrow: 2},
    ];

    this.searchTerm = new FormControl();

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.userList && this.userList) {
      this.rows = this.userList;
    }
  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.userList;
    } else {
      if (this.userList) {
        this.rows = this.userList.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onCellUpdate(row, res, index) {

  }

  rowFormat(row) {

    let cls = {};

    cls['pinned-down'] = row.is_deactivated;
    cls['deactivated'] = row.is_deactivated;

    return cls;
  }

  onEditUserClicked(user: IUser) {
    this.currentUserItem = user;
    this.currentUserControl = UserFormComponent.initControl(this.fb);
    this.userModal.show();
  }

  saveUser() {
    this.dataSubscriptions.push(this.userService.updateUser(this.currentUserItem.cuid, this.currentUserControl.value)
      .subscribe(
        res => this.sessionActions.pushMessage("Benutzerdaten erfolgreich atkualisiert", MessageType.SUCCESS),
        err => this.sessionActions.throwError(err, "Fehler beim Aktualisieren des Benutzers!")
      ));
  }

  deleteUser(user: IUser) {
    this.dataSubscriptions.push(this.userService.deleteUser(user.cuid).subscribe(
      res => this.sessionActions.pushMessage("Benutzerdaten erfolgreich gelöscht", MessageType.SUCCESS),
      err => this.sessionActions.throwError(err, "Fehler beim Löschen des Benutzers!")
    ));
  }

  onResetPasswordClicked(user: IUser) {
    this.dataSubscriptions.push(this.userService.resetPasswordForUser(user.cuid).subscribe(
      res => this.sessionActions.pushMessage("Password zurückgesetzt. Der Benutzer wurde über sein neues Password per E-Mail informiert.", MessageType.SUCCESS),
      err => this.sessionActions.throwError(err, "Fehler beim Zurücksetzen des Passworts!")
    ));
  }

  reactivateUserAccount(user: IUser) {
    this.dataSubscriptions.push(
      this.userService.reactivateUserAccount(user.cuid, user.email).subscribe(
        res => this.sessionActions.pushMessage("Benutzer-Account wurde erfolgreich reactiviert!", MessageType.SUCCESS),
        err => this.sessionActions.throwError(err, "Fehler beim Re-Aktivieren des Benutzer-Accounts!")
      )
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/user-list/user-list.component.ts